(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gk-design-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initDP(root) {
      if (!root || root.dataset.dpInit) return;
      root.dataset.dpInit = '1';
      var main = root.querySelector('[data-dp-main] img');
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-dp-thumb]'));
      if (!main || !thumbs.length) return;
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var full = t.getAttribute('data-full');
          if (full) main.src = full;
          thumbs.forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    }
    function initAll() { document.querySelectorAll('.gk-dp').forEach(initDP); }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-dp');
      if (el) initDP(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initGallery(root) {
      if (!root || root.dataset.gkInit) return;
      root.dataset.gkInit = '1';
      var grid = root.querySelector('[data-grid]');
      if (!grid) return; // empty state — nothing to wire up
      var tiles = Array.prototype.slice.call(root.querySelectorAll('.gk-gallery__tile'));
      var countEl = root.querySelector('[data-count]');
      var activeBar = root.querySelector('[data-active-bar]');
      var pager = root.querySelector('[data-pager]');
      var perPage = parseInt(root.dataset.perPage, 10) || 18;
      var page = 1;

      // mobile filter drawer toggle
      var filterToggle = root.querySelector('[data-filter-toggle]');
      if (filterToggle) {
        filterToggle.addEventListener('click', function () {
          var sidebar = filterToggle.closest('.gk-gallery__sidebar');
          var open = sidebar.classList.toggle('is-open');
          filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
          var icon = filterToggle.querySelector('span');
          if (icon) icon.textContent = open ? '−' : '+';
        });
      }

      // group collapse
      root.querySelectorAll('[data-group-toggle]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var group = btn.closest('.gk-gallery__group');
          var open = group.classList.toggle('is-open');
          var icon = btn.querySelector('.gk-gallery__group-icon');
          if (icon) icon.textContent = open ? '−' : '+';
        });
      });

      function vals(tile, facet) {
        var raw = tile.getAttribute('data-' + facet) || '';
        return raw.split('|').map(function (s) { return s.trim(); }).filter(Boolean);
      }
      function checked(facet) {
        return Array.prototype.slice.call(root.querySelectorAll('input[data-facet="' + facet + '"]:checked'))
          .map(function (i) { return i.value; });
      }
      function matches(tile) {
        var facets = ['event', 'theme', 'garment'];
        for (var i = 0; i < facets.length; i++) {
          var sel = checked(facets[i]);
          if (!sel.length) continue;
          var tv = vals(tile, facets[i]);
          var hit = sel.some(function (s) { return tv.indexOf(s) !== -1; });
          if (!hit) return false;
        }
        return true;
      }

      function renderChips() {
        var all = [];
        ['event', 'theme', 'garment'].forEach(function (f) {
          checked(f).forEach(function (v) { all.push({ facet: f, value: v }); });
        });
        if (!all.length) {
          activeBar.innerHTML = '<span class="gk-gallery__active-empty">No filters applied — showing all designs</span>';
          return;
        }
        activeBar.innerHTML = '';
        all.forEach(function (item) {
          var chip = document.createElement('span');
          chip.className = 'gk-gallery__chip';
          chip.textContent = item.value + ' ';
          var x = document.createElement('button');
          x.type = 'button';
          x.setAttribute('aria-label', 'Remove ' + item.value);
          x.textContent = '×';
          x.addEventListener('click', function () {
            var box = null;
            root.querySelectorAll('input[data-facet="' + item.facet + '"]').forEach(function (i) {
              if (i.value === item.value) box = i;
            });
            if (box) { box.checked = false; apply(); }
          });
          chip.appendChild(x);
          activeBar.appendChild(chip);
        });
      }

      function apply() {
        var visible = tiles.filter(matches);
        page = 1;
        paint(visible);
        renderChips();
      }

      function paint(visible) {
        var pages = Math.max(1, Math.ceil(visible.length / perPage));
        if (page > pages) page = pages;
        var start = (page - 1) * perPage;
        var end = start + perPage;
        tiles.forEach(function (t) { t.classList.add('is-hidden'); });
        visible.slice(start, end).forEach(function (t) { t.classList.remove('is-hidden'); });
        if (countEl) countEl.textContent = 'Showing ' + visible.length + ' design' + (visible.length === 1 ? '' : 's');
        renderPager(pages, visible);
      }

      function renderPager(pages, visible) {
        pager.innerHTML = '';
        if (pages <= 1) return;
        for (var p = 1; p <= pages; p++) {
          (function (p) {
            var b = document.createElement('button');
            b.type = 'button';
            b.textContent = p;
            if (p === page) b.className = 'is-active';
            b.addEventListener('click', function () {
              page = p; paint(visible);
              var top = root.getBoundingClientRect().top + window.pageYOffset;
              window.scrollTo({ top: top, behavior: 'smooth' });
            });
            pager.appendChild(b);
          })(p);
        }
      }

      root.querySelectorAll('input[data-facet]').forEach(function (i) {
        i.addEventListener('change', apply);
      });
      tiles.forEach(function (t) {
        t.addEventListener('click', function () {
          var link = t.getAttribute('data-link');
          if (link) window.location.href = link;
        });
      });

      apply();
    }
    function initAll() {
      document.querySelectorAll('.gk-gallery').forEach(initGallery);
    }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-gallery');
      if (el) initGallery(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gk-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeroSlideshow(root) {
      var box = root.querySelector('[data-gk-hero-slideshow]');
      if (!box || box.dataset.gkInit) return;
      box.dataset.gkInit = '1';
      var slides = box.querySelectorAll('.gk-hero__slide');
      if (slides.length < 2) return;
      var dotsWrap = box.querySelector('.gk-hero__dots');
      var idx = 0;
      var dots = [];
      if (dotsWrap) {
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'gk-hero__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { show(i); });
          dotsWrap.appendChild(d);
          dots.push(d);
        });
      }
      function show(n) {
        slides[idx].classList.remove('is-active');
        if (dots[idx]) dots[idx].classList.remove('is-active');
        idx = (n + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dots[idx]) dots[idx].classList.add('is-active');
      }
      var speed = parseInt(box.dataset.autoplay, 10) || 3500;
      if (speed > 0) setInterval(function () { show(idx + 1); }, speed);
    }
    function initAll() {
      document.querySelectorAll('.gk-hero').forEach(function (el) { initHeroSlideshow(el); });
    }
    if (document.readyState !== 'loading') initAll(); else document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.gk-hero');
      if (el) initHeroSlideshow(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
